/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Header_Sign_In_LabelInputs */



/**
* | output |
* | --- |
* | "Sign in (opens in a new tab)" |
*
* @param {Header_Sign_In_LabelInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
export const header_sign_in_label = /** @type {((inputs?: Header_Sign_In_LabelInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Header_Sign_In_LabelInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "zh") return /** @type {LocalizedString} */ ("登录（在新标签页中打开）")
	return /** @type {LocalizedString} */ ("Sign in (opens in a new tab)")
});